import {FC} from "react";
import {Route, Routes, useParams, useLocation} from "react-router-dom";
import {PageBase} from "../../components/pageBase/pageBase";
import {CurriculumProvider} from "../../contexts/curriculumContext";
import {CourseCertificatePage} from "../CourseCertificatePage/CourseCertificatePage";
import {ModulePage} from "../ModulePage/ModulePage";
import {CourseLandingPage} from "./CourseLandingPage";
import {CourseSideMenuContent} from "./CourseSideMenuContent";
import {MobileTrainingFeedDrawer} from "../../components/pageBase/mobileTrainingFeedDrawer";
import {makeStyles} from "tss-react/mui";
import {useOrientation} from "../../hooks/useOrientation";

// Common styles to fix black bar on video player
const videoElementStylesContain = {
	"& video, & iframe": {
		position: "absolute !important" as any,
		top: "0 !important" as any,
		left: "0 !important" as any,
		width: "100% !important" as any,
		height: "100% !important" as any,
		objectFit: "contain" as any
	},
	"& > div": {
		position: "absolute !important" as any,
		top: "0 !important" as any,
		left: "0 !important" as any,
		width: "100% !important" as any,
		height: "100% !important" as any
	}
};

const createVideoPlayerStyles = (background: string): Record<string, any> => ({
	top: "0 !important" as any,
	width: "100% !important" as any,
	background: `${background} !important` as any,
	...videoElementStylesContain
});

const useStyles = makeStyles<{ shouldHideUI: boolean }>()((theme, {shouldHideUI}) => ({
	pageBase: {
		...(!shouldHideUI && {
			"& [class*='videoPlayerBackdrop']": {
				position: "relative !important" as any,
				paddingBottom: "56.25% !important" as any,
				height: "0 !important" as any,
				width: "100% !important" as any,
				background: "transparent !important" as any,
				...videoElementStylesContain
			},
			"& [class*='videoPlayer']": createVideoPlayerStyles("transparent")
		}),
		...(shouldHideUI && {
			"& [class*='navBar']": {
				display: "none"
			},
			"& [class*='contentContainer']": {
				position: "fixed",
				top: 0,
				height: "100vh",
				overflowY: "hidden",
				zIndex: 9998
			},
			"& [class*='sideMenu']": {
				display: "none"
			},
			"& > [class*='MobileNavBar']": {
				display: "none"
			},
			"& [class*='videoPlayerBackdrop']": {
				position: "fixed",
				paddingBottom: 0,
				height: "100vh",
				zIndex: 9999,
				top: 0,
				left: 0,
				right: 0,
				background: "black !important" as any,
				...videoElementStylesContain
			},
			"& [class*='videoPlayer']": createVideoPlayerStyles("black")
		})
	}
}));

export const CoursePage: FC = () => {
	const {courseSlug} = useParams();
	const location = useLocation();
	const isLandscape = useOrientation();
	const isLessonPage = location.pathname.includes("/lesson/");
	const shouldHideUI = isLandscape && isLessonPage;
	const {classes} = useStyles({shouldHideUI});

	return (
		<CurriculumProvider courseSlug={courseSlug}>
			<PageBase className={classes.pageBase} sideBarContent={<CourseSideMenuContent />} contentWidth={"3000px"} disableFooter={true}>
				<Routes>
					<Route index element={<CourseLandingPage />} />
					<Route path="complete" element={<CourseCertificatePage />} />
					<Route path=":moduleType/:moduleSlug/*" element={<ModulePage />} />
				</Routes>
				<MobileTrainingFeedDrawer />
			</PageBase>
		</CurriculumProvider>
	);
}
